import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Radio, Button, Form } from 'antd';

const RadioType = ({ question, onEdit, onChange }) => {
  const [selectedOption, setSelectedOption] = useState();
  const [form] = Form.useForm();

  const setFieldValue = useCallback(
    () => {
      setSelectedOption();
      if (question.selectedAnswer) {
        form.setFieldsValue({ option: question.selectedAnswer });
        setSelectedOption(question.selectedAnswer.toString());
      }
    },
    [question.selectedAnswer, question.title],
  );

  const onFinish = (values) => {
    onChange(question.testId, question.groupId, question.questionId, selectedOption);
    form.resetFields();
  };

  const handleRadioButton = (event) => {
    setSelectedOption(event.target.value.toString());
  };

  useEffect(() => {
    form.resetFields();
    setFieldValue();
  }, [setFieldValue]);

  return (
    <Row justify="center">
      <Form
        initialValues={{ option: question.selectedAnswer }}
        onFinish={onFinish}
        form={form}
        style={{ width: '100%' }}
      >
        <Col md={24}>
          <Row justify="center">
            <Col md={24} className={question.isChecked ? "options-wrapper p-30 mt-40 mb-80" : "options-wrapper p-30 mt-20 mb-40"}>
              <Row justify="center">
                {
                  question.questionTitle &&
                  <Col md={24}>
                    <h2 className="text-center mt-10 mb-50" dangerouslySetInnerHTML={{ __html: question.questionTitle && question.questionTitle }} />
                  </Col>
                }
                <Col md={24}>
                  <Form.Item
                    name="option"
                    className="mb-0"
                  >
                    <Radio.Group
                      style={
                        question.questionOptions.length <= 2
                          ? { width: '100%', display: 'flex', justifyContent: 'center' }
                          : { width: '100%', display: 'flex', justifyContent: 'space-between' }}
                    >
                      {
                        question.questionOptions && question.questionOptions.map((option, index) =>
                          <Col
                            key={index}
                            style={!question.questionTitle ? { width: '48%' } : { width: (100 / (question.questionOptions.length + 1)) + '%' }}
                            className={question.questionOptions.length <= 2 && "two-options-text"}
                          >
                            <Radio.Button
                              value={option.text.toString()}
                              className={question.questionTitle ? "radio-button-title" : "radio-button-no-title"}
                              defaultChecked={false}
                              onChange={e => { onEdit(question.questionId, e.target.value); handleRadioButton(e); }}
                            >
                              <p className="mb-0">{option.text}</p>
                            </Radio.Button>
                          </Col>
                        )
                      }
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          {
            question && !question.isChecking &&
            <Row justify="end" className="mb-40">
              <Col md={6}>
                <Button
                  disabled={!selectedOption}
                  className={!selectedOption ? 'button-disabled' : ''}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  block
                >
                  Confirmar cambio
                </Button>
              </Col>
            </Row>
          }

        </Col>
      </Form>
    </Row>
  );
};

export default RadioType;